import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="w-full mt-16 bg-primary-950 text-primary-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-lg bg-accent-500 text-foreground-950 flex items-center justify-center">
                <i className="ri-film-line text-xl"></i>
              </span>
              <span className="font-heading font-extrabold text-xl text-background-50">快活影院</span>
            </div>
            <p className="text-sm leading-relaxed text-primary-200 max-w-md">
              快活影院是一个影视内容展示平台，汇聚电影、电视剧的作品资料、观影指南与行业资讯，
              帮助影视爱好者快速找到心仪的作品。
            </p>
            <p className="mt-4 text-xs text-primary-300">
              本站为内容展示演示站点，不提供播放、下载与会员服务，全部资料均为示例展示。
            </p>
          </div>

          <nav aria-label="快捷导航">
            <h4 className="font-heading font-semibold text-background-50 mb-4">
              <Link to="/" className="hover:text-accent-400 transition-colors">快捷导航</Link>
            </h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/category/movie" className="text-primary-200 hover:text-accent-400 transition-colors">电影频道</Link></li>
              <li><Link to="/category/tv" className="text-primary-200 hover:text-accent-400 transition-colors">电视剧频道</Link></li>
              <li><Link to="/news" className="text-primary-200 hover:text-accent-400 transition-colors">影视资讯</Link></li>
              <li><Link to="/about" className="text-primary-200 hover:text-accent-400 transition-colors">关于我们</Link></li>
            </ul>
          </nav>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">
              <Link to="/about" className="hover:text-accent-400 transition-colors">联系我们</Link>
            </h4>
            <ul className="space-y-3 text-sm text-primary-200">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400"></i>
                <span>hello@kuaihuo-demo.example</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-weibo-line text-accent-400"></i>
                <span>@快活影院（示例账号）</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line text-accent-400"></i>
                <span>kuaihuo_demo（示例）</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-primary-300">
          <p>© 2025 快活影院 · 内容演示站点，所涉影视资料与联系方式均为虚构示例</p>
          <div className="flex items-center gap-4">
            <Link to="/about" className="hover:text-accent-400 transition-colors">使用声明</Link>
            <Link to="/about" className="hover:text-accent-400 transition-colors">隐私政策</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}